import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SaveItemViewService {
  private itemSavedSubject = new Subject<any>();
  itemSaved$: Observable<any>;

  constructor() {
    this.itemSaved$ = this.itemSavedSubject.asObservable();
  }

  notifyItemSaved(item: any) {
    this.itemSavedSubject.next(item);
  }
}
